import React from "react";
import { Props } from "./Props";

const BriefcaseIcon: React.FC<Props> = ({ fill, otherProps }) => {
  const { width, height } = otherProps;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.558 11.6154V10.5409C33.558 9.7512 32.9179 9.11105 32.1282 9.11105H23.9987C23.2091 9.11105 22.5689 9.7512 22.5689 10.5409L22.5689 11.6154"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="square"
      />
      <rect
        x="25.4139"
        y="23.3442"
        width="8.49368"
        height="10.4242"
        rx="1.4442"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.79386 21.8933V22.6433V27.6797C8.79386 28.7576 9.6677 29.6314 10.7456 29.6314H19.991H20.741V31.1314H19.991H10.7456C8.83927 31.1314 7.29386 29.586 7.29386 27.6797V22.6433V21.8933H8.79386ZM48.7061 21.8933V22.6433V27.6797C48.7061 29.586 47.1607 31.1314 45.2544 31.1314H36.2619H35.5119V29.6314H36.2619H45.2544C46.3323 29.6314 47.2061 28.7576 47.2061 27.6797V22.6433V21.8933H48.7061Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.29386 14.1548H8.04386H47.9561H48.7061V14.9048V34.1265V36.9882V37.0221C48.7061 38.5949 48.7061 39.8214 48.6257 40.8056C48.544 41.8057 48.3756 42.6216 48.001 43.3567C47.3808 44.5739 46.3912 45.5636 45.1739 46.1838C44.4388 46.5583 43.6229 46.7268 42.6229 46.8085C41.6386 46.8889 40.4122 46.8889 38.8393 46.8889H38.8054H33.3903H8.04386H7.29386V46.1389V35.9283V35.1783H8.79386V35.9283V45.3889H33.3903H38.8054C40.4193 45.3889 41.5846 45.3883 42.5007 45.3135C43.408 45.2393 44.0046 45.0961 44.4929 44.8473C45.4279 44.3709 46.1881 43.6107 46.6645 42.6757C46.9134 42.1873 47.0566 41.5908 47.1307 40.6835C47.2056 39.7674 47.2061 38.6021 47.2061 36.9882V34.1265V15.6548H8.79386V27.4559V28.2059H7.29386V27.4559V14.9048V14.1548Z"
        fill="black"
      />
      <rect
        x="23.9628"
        y="25.4831"
        width="8.08322"
        height="9.9205"
        stroke="black"
        stroke-width="1.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_710_6326"
          x1="29.6608"
          y1="23.3442"
          x2="29.6608"
          y2="33.7684"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFA543" />
          <stop offset="1" stop-color="#FFCC83" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BriefcaseIcon;
